export default __webpack_public_path__ + "static/media/Power_of_Attorney.a1fba579.pdf";